((factory) => {
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory();
    } else {
        angular.module('cpm').constant('ErrorUtils', factory());
    }
})(() => {

    const TYPE_NAMES = {auth: 'user', admin: 'user'};

    const asText = (val) => (typeof val === 'string' && val.trim() !== '') ? val : null;

    const isBinary = (body) => typeof ArrayBuffer !== 'undefined' &&
        (body instanceof ArrayBuffer || ArrayBuffer.isView(body));

    const decodeBinary = (body) => {
        let text;
        try {
            text = new TextDecoder().decode(body);
        } catch (e) {
            return null;
        }
        try {
            return JSON.parse(text);
        } catch (e) {
            return text;
        }
    };

    const normalizeErrorBody = (body) => {
        const result = {statusMessage: null, errorType: null, reason: null};

        if (isBinary(body)) {
            body = decodeBinary(body);
        }

        if (body === null || body === undefined) {
            return result;
        }

        if (typeof body === 'string') {
            result.reason = asText(body);
            return result;
        }

        if (typeof body !== 'object') {
            result.reason = String(body);
            return result;
        }

        result.statusMessage = asText(body.statusMessage);

        const data = body.data;
        if (data && typeof data === 'object') {
            result.errorType = asText(data.errorType);
            result.reason = asText(data.error);
        }
        else if (typeof data === 'string') {
            result.reason = asText(data);
        }

        if (result.reason === null) {
            result.reason = asText(body.message);
        }

        return result;
    };

    const shouldNotify = (rejection, apiBase) => {
        const config = (rejection && rejection.config) || {};
        const url = config.url || '';

        if (config.silent) return false;
        if (!url.startsWith(apiBase)) return false;
        if (rejection.status === 401) return false;
        if (rejection.xhrStatus === 'abort') return false;

        return true;
    };

    const describeFailedRequest = (config, apiBase) => {
        config = config || {};
        if (asText(config.errorMessage)) {
            return config.errorMessage;
        }

        const method = (config.method || 'GET').toUpperCase();
        let path = (config.url || '').split('?')[0];
        if (path.startsWith(apiBase)) {
            path = path.substring(apiBase.length);
        }

        const segments = path.split('/').filter(s => s !== '');
        if (segments.length === 0) {
            return 'The request failed.';
        }

        const type = TYPE_NAMES[segments[0]] || segments[0].replace(/[-_]/g, ' ');
        const rest = segments.slice(1);

        if (rest[0] === 'list') return `Failed to load ${type}s.`;
        if (rest[0] === 'update') return `Failed to update ${type}.`;
        if (rest.includes('clone')) return `Failed to copy ${type}.`;
        if (rest.length === 0 && method === 'POST') return `Failed to create ${type}.`;

        if (method === 'GET') return `Failed to load ${type}.`;
        if (method === 'DELETE' || rest[rest.length - 1] === 'delete') return `Failed to delete ${type}.`;
        return `Failed to save ${type}.`;
    };

    const isRetryable = (rejection) => !!rejection && (rejection.status >= 500 || rejection.status <= 0);

    const failureMessage = (rejection, apiBase) => {
        const config = (rejection && rejection.config) || {};
        const message = describeFailedRequest(config, apiBase);
        if (asText(config.errorMessage) || !isRetryable(rejection)) {
            return message;
        }
        return `${message.replace(/[.!\s]+$/, '')}, please try again later.`;
    };

    return {
        normalizeErrorBody,
        shouldNotify,
        describeFailedRequest,
        failureMessage
    };

});
